module.exports = __webpack_public_path__ + "img/poster.fc125b81.png";